import { ChevronUp } from 'lucide-react'

import { cn } from '../lib/cn'

export type VoteButtonProps = {
  voteCount: number
  hasVoted: boolean
  pending: boolean
  onVote: () => void
}

export const VoteButton = ({
  voteCount,
  hasVoted,
  pending,
  onVote,
}: VoteButtonProps): JSX.Element => (
  <button
    type="button"
    disabled={pending}
    aria-pressed={hasVoted}
    onClick={(event) => {
      event.preventDefault()
      event.stopPropagation()
      onVote()
    }}
    className={cn(
      'flex h-16 w-14 shrink-0 flex-col items-center justify-center gap-0.5 rounded-xl border bg-white transition-colors',
      'disabled:opacity-60',
      hasVoted
        ? 'border-dune-accent bg-orange-50 text-dune-accent'
        : 'border-dune-border text-dune-text hover:border-dune-accent',
    )}
  >
    <ChevronUp className="h-4 w-4" strokeWidth={2.5} />
    <span className="font-display text-base font-medium leading-none">
      {voteCount}
    </span>
  </button>
)
